import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { axiosClient } from '@as-react/common-utils';
import { CookieFillIcon } from '@yonderland/andes-icons';
import { Box, ButtonAlpha, LinkButton, Prose, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import BrowserUtil from '../../../util/BrowserUtil';
import { COOKIE_TABS } from './CookieMessage';
export const CookieDefaultMessage = ({ title, description, btnLabel, moreOptions, privacyLinkText, privacyLinkHref, setActiveTab, setPrivacyData, checkedPreferences, onAcceptAllCookies, }) => {
    const [isBrowserInstagram, setIsBrowserInstagram] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        setIsBrowserInstagram(BrowserUtil.isBrowserInstagram());
    }, []);
    const showCookiePreferences = (e) => {
        e.preventDefault();
        setActiveTab(COOKIE_TABS.PREFERENCES);
        dispatch(analyticsActions.cookieConsentOpenPreferences(checkedPreferences));
    };
    const showCookiePrivacy = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const axiosConfig = {
            method: 'GET',
            url: privacyLinkHref,
        };
        try {
            const res = yield axiosClient.request(axiosConfig);
            setPrivacyData(res.data);
            setActiveTab(COOKIE_TABS.PRIVACY);
        }
        catch (_a) { }
    });
    return (_jsx(Box, { paddingBlockEnd: {
            base: isBrowserInstagram ? '20' : '0',
            md: isBrowserInstagram ? '20' : '2',
        }, children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(TextAlpha, { variant: "headingS", children: title }), _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(Prose, { html: description }), _jsx(Box, { paddingBlockEnd: { base: '2', md: '6' }, children: _jsx(LinkButton, { tabIndex: 0, testId: "cookie-privacy-link", variant: "primary", onClick: showCookiePrivacy, children: privacyLinkText }) })] }), _jsx(ButtonAlpha, { tabIndex: 0, testId: "accept-all-cookies", onClick: onAcceptAllCookies, autoFocus: true, iconRight: {
                        source: CookieFillIcon,
                    }, fullWidth: true, children: btnLabel }), _jsx(Box, { children: _jsx(LinkButton, { tabIndex: 0, testId: "cookie-preferences-link", variant: "primary", onClick: showCookiePreferences, children: moreOptions }) })] }) }));
};
